<template>
  <div class="user_page">
    <div class="text-right d-flex justify-space-between align-center">
      <div class="d-flex align-center">
        <BackBtn class="mr-3" />
        <h3 class="title-page">Create Stellage</h3>
      </div>
      <VBtn color="primary" @click="save">{{ $t("save") }}</VBtn>
    </div>
    <div>
      <div class="admin_container">
        <div class="division_main">
          <warehouse-stillage @save="save" :data="boardData" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WarehouseStillage from "@/components/warehouse/WarehouseStillage";
import BackBtn from "@/components/ui/BackBtn";
import { DEFAULT_STILLAGE_BOX_SIZE } from "@/utils/constants";
import { BoxService } from "@/services/BoxService.js";

export default {
  components: { WarehouseStillage, BackBtn },
  props: {
    warehouseId: {},
    columnId: {},
    cellId: {},
  },
  data() {
    return {
      boardData: {
        boards: [],
        columns: [],
        rows: [],
      },
    };
  },
  methods: {
    async getBoard() {
      try {
        const { stillageId, cellId } = this;
        const {
          data: { data },
        } = await this.$http.get("stillage/board", {
          params: { stillageId, cellId },
        });
        const boxService = new BoxService(DEFAULT_STILLAGE_BOX_SIZE);
        this.boardData = {
          ...boxService.parseData(data),
          id: this.id,
        };
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async save() {
      this.showLoading();
      try {
        await this.$http.post("stillage/setup", {
          cellIds: [this.cellId],
          id: this.columnId,
          columnCount: this.boardData.boards.length,
          warehouseId: this.warehouseId,
          rowCounts: this.boardData.boards.map((item) => {
            return item.length;
          }),
        });
        await this.getBoard();
        this.setSuccess({ text: this.$t("successfullySaved") });
      } catch (e) {
        this.setResponseError({
          error: e,
        });
      } finally {
        this.clearLoading();
      }
    },
  },
  async created() {
    this.showLoading();
    await this.getBoard();
    this.clearLoading();
  },
};
</script>
